import { useQuery } from "@tanstack/react-query";
import { MySignedCardsResponse } from "tng-address-collection-shared/types/apiTypes.ts";
import { useAuthentication } from "../auth/useAuthentication.ts";
import { queryKeys } from "./queryKeys.ts";

export const useMySignedCards = () => {
  const { getToken, isAuthenticated } = useAuthentication();

  return useQuery({
    queryKey: queryKeys.mySignedCards(),
    queryFn: async ({ signal }): Promise<MySignedCardsResponse> => {
      const token = await getToken();

      const response = await fetch("/api/cards/my-signed-cards", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        signal,
      });

      if (!response.ok) {
        throw new Error(`Failed to load my cards: ${response.status}`);
      }

      return (await response.json()) as MySignedCardsResponse;
    },
    enabled: isAuthenticated,
    retry: false,
  });
};
